import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'none';

/**
 * To use logger either inject:
 *   private logger = inject(LoggerService);
 * or use dependency injection:
 *   constructor(private logger: LoggerService) {}
 *
 * usage:
 * this.logger.debug('Debug statement');
 * this.logger.error('Error statement');
 *
 * Lower environments will show all types of log statements,
 * prod will show none.
 */

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  private logLevel: LogLevel = environment.logLevel as LogLevel;

  debug(...args: unknown[]) {
    if (this.shouldLog('debug')) console.debug('[DEBUG]', ...args);
  }

  info(...args: unknown[]) {
    if (this.shouldLog('info')) console.info('[INFO]', ...args);
  }

  warn(...args: unknown[]) {
    if (this.shouldLog('warn')) console.warn('[WARN]', ...args);
  }

  error(...args: unknown[]) {
    if (this.shouldLog('error')) console.error('[ERROR]', ...args);
  }

  private shouldLog(level: LogLevel): boolean {
    const order: LogLevel[] = ['debug', 'info', 'warn', 'error', 'none'];
    return order.indexOf(level) >= order.indexOf(this.logLevel);
  }
}
